//import axios, { CancelTokenSource } from 'axios';
import sanityClient from '@sanity/client';

export interface Programme {
  id: number;
  createdAt: Date;
  name: string;
  sets: Set[];
};

export interface Set {
  id: number;
  name: string;
  rounds: number;
  setName: string;
  setNote: string;
  comment: string;
  timerSets?: number;
  timerWork?: number;
  repetitions: Repetition[];
};

export interface Repetition {
  id: number;
  name: string;
  comment: string;
  repetitions: string;
  exercises: Exercise[];
};

export interface Exercise {
  id: number;
  name: string;
  url: string;
}

const client = sanityClient({
  projectId: 'pfk2920x',
  dataset: 'production',
  apiVersion: 'v1', // use current UTC date - see "specifying API version"!
  useCdn: false, // `false` if you want to ensure fresh data
})

//export async function GetProgrammes(cancelToksenSource: CancelTokenSource = axios.CancelToken.source()) : Promise<Programme[]> {
  export async function GetProgrammes() : Promise<Programme[]> {
  const query = `*[_type == 'programme'] | order(_createdAt desc) {
    'id': _id,
    name,
    sets[]->{
      'id': _id,
      'createdAt': _createdAt,
      name,
      rounds,
      setName,
      setNote,
      comment,
      timerSets,
      timerWork,
      repetitions[]->{
        'id': _id,
        name,
        comment,
        repetitions,
        exercises[]->{
          'id': _id,
          name,
          url
        }
      }
    }
  }`;

  return await client.fetch(query)
  .then((response) => {
    return response;
  })
  .catch((error) => {
    throw new Error(`getProgrammes: ${error}`);
  });

  // return await axios.get(`programmes.json?date=20210530`, {
  //   cancelToken: cancelToksenSource.token
  // })
  // .then((response) => {
  //   return response.data.data.programmes;
  // })
  // .catch((error) => {
  //   throw new Error(`getProgrammes: ${error}`);
  // });
};